import { MessageType } from './Chat.types';

export const DEFAULT_CHAT_CONFIG = {
  [MessageType.BOT_GENERATING]: {
    delayPerLine: 0,
    typeSpeed: 100,
    loadingDotTypeSpeed: 1000,
  },
};

export const DELAY_TO_LIVE_READING = 1000;
